import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [orgId, setOrgId] = useState(null);
  const [orgName, setOrgName] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Retry up to 5 times to handle signup timing
        let userData = null;
        for (let i = 0; i < 5; i++) {
          const docRef = doc(db, 'users', user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            userData = docSnap.data();
            break;
          }
          await new Promise(res => setTimeout(res, 800));
        }

        if (userData) {
          setUserRole(userData.role);
          setOrgId(userData.orgId);

          if (userData.orgId) {
            const orgRef = doc(db, 'organizations', userData.orgId);
            const orgSnap = await getDoc(orgRef);
            if (orgSnap.exists()) {
              setOrgName(orgSnap.data().name);
            }
          }
        }
        setCurrentUser(user);
      } else {
        setCurrentUser(null);
        setUserRole(null);
        setOrgId(null);
        setOrgName(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    userRole,
    orgId,
    orgName,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}